var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const popupAuthAccordion = () => {
    const accordionTitles = document.querySelectorAll('.js-popup-accordion-title');
    const accordionContents = document.querySelectorAll('.js-popup-accordion-content');
    accordionTitles &&
        [...accordionTitles].forEach((titleBtn) => {
            titleBtn.addEventListener('click', (event) => {
                var _a;
                const target = event.target;
                const accordionTab = (_a = target.dataset) === null || _a === void 0 ? void 0 : _a.id;
                accordionContents &&
                    [...accordionContents].forEach((contentPanel) => {
                        contentPanel.classList.remove('active');
                        if (contentPanel.id === accordionTab) {
                            contentPanel.classList.add('active');
                        }
                    });
            });
        });
};
const submitHandler = (formDomElement, action) => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData(formDomElement);
    formData.append('action', action);
    const response = yield fetch(var_from_php.ajax_url, {
        method: 'POST',
        body: formData,
    });
    const respJson = yield response.json();
    return respJson;
});
export const registrationCustomer = () => {
    const formRegistration = document.querySelector('.js-registration');
    const loginAndBookmarkBtn = document.querySelector('.js-login-and-add-to-bookmark');
    formRegistration &&
        formRegistration.addEventListener('submit', (event) => __awaiter(void 0, void 0, void 0, function* () {
            event.preventDefault();
            const requestResult = yield submitHandler(formRegistration, 'try_to_registration_customer');
            if (requestResult === null || requestResult === void 0 ? void 0 : requestResult.success) {
                window.location.href = loginAndBookmarkBtn.href;
            }
            console.log('authSMSWayForm requestResult', requestResult);
        }));
};
export const authFormSubmitHandler = () => {
    const authSMSWayForm = document.querySelector('.js-auth-via-sms');
    const authEmailWayForm = document.querySelector('.js-auth-via-email');
    const loginAndBookmarkBtn = document.querySelector('.js-login-and-add-to-bookmark');
    authSMSWayForm &&
        authSMSWayForm.addEventListener('submit', (event) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            event.preventDefault();
            const requestResult = yield submitHandler(authSMSWayForm, 'try_to_authorize_customer');
            if (requestResult === null || requestResult === void 0 ? void 0 : requestResult.success) {
                const code_message = authSMSWayForm.querySelector('.js-message-code');
                if (code_message) {
                    code_message.innerHTML = '';
                }
                if ((_a = requestResult === null || requestResult === void 0 ? void 0 : requestResult.data) === null || _a === void 0 ? void 0 : _a.show_form) {
                    if (((_b = requestResult === null || requestResult === void 0 ? void 0 : requestResult.data) === null || _b === void 0 ? void 0 : _b.message) && code_message) {
                        code_message.innerHTML = (_c = requestResult === null || requestResult === void 0 ? void 0 : requestResult.data) === null || _c === void 0 ? void 0 : _c.message;
                    }
                    const hide_code = authSMSWayForm.querySelector('.js-hide-code');
                    const phone = document.querySelector('#auth-via-sms-input');
                    if (hide_code && phone) {
                        hide_code.classList.remove('hide-code');
                    }
                }
            }
            console.log('requestResult?.login', requestResult, requestResult === null || requestResult === void 0 ? void 0 : requestResult.login);
            if (requestResult === null || requestResult === void 0 ? void 0 : requestResult.login) {
                window.location.href = loginAndBookmarkBtn.href;
            }
        }));
    authEmailWayForm &&
        authEmailWayForm.addEventListener('submit', (event) => __awaiter(void 0, void 0, void 0, function* () {
            event.preventDefault();
            const requestResult = yield submitHandler(authEmailWayForm, 'try_to_authorize_customer');
            if (requestResult === null || requestResult === void 0 ? void 0 : requestResult.success) {
                window.location.href = loginAndBookmarkBtn.href;
            }
            console.log('authEmailWayForm requestResult', requestResult);
        }));
};
